import React, {useState, useEffect, useRef} from 'react';
import CarouselInicio from '../Inicio/CarouselInicio/index';
import NuestrosProductos from '../Inicio/NuestrosProductos/index';
import NuestrosClientes from '../Inicio/NuestrosClientes/index';
import { useLocation } from 'react-router-dom';

export default function Inicio(props){

  const nuestrosProductos = useRef(null);
  const url = useLocation();
  const [helper, setHelper] = useState(0)


  useEffect(() => {
    if(nuestrosProductos !==null){
    if(url.hash !== ''){
        switch (url.hash) {
            case '#products':
                window.scrollTo(0,nuestrosProductos.current.offsetTop - 20);
                break;
            default:
             window.scrollTo(0, 0);
                break;
        }
    }}
 }, [url.hash, helper])


 useEffect(() => {
   setInterval(() => {
     setHelper(1)
   }, 100);
 }, [])


    return(<>
    <div style={{height: '20px'}}></div>
    <CarouselInicio/>
    <div ref={nuestrosProductos} style={{height: '20px'}}></div>
    <NuestrosProductos/>
    <div style={{height: '20px'}}></div>
    <NuestrosClientes/>
    <div style={{height: '20px'}}></div>
    </>)
}